exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-title {\n  display: flex;\n  align-items: center;\n}\n.post-title img {\n  margin-right: 10px;\n  border-radius: 2px;\n}\n.post-title a {\n  color: #546b81;\n  font-size: 14px;\n  text-decoration: none;\n}\n.post-title a:hover {\n  text-decoration: underline;\n}", ""]);

// exports
